
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form12";
const form12State = namespace("Form12");

import Form12ProcessHeader from "@/components/process/Form12/components/Form12ProcessHeader.vue";
import Form12 from "@/components/process/Form12/components/pdf/Form12.vue"

import { form12StatusInfoType } from '@/types/Information/Form12';

@Component({
    components:{
        Form12ProcessHeader,
        Form12
    }
})
export default class PreviewForm12 extends Vue {

    @form12State.State
    public currentOrderToVarySingleJusticeId: string;

    stepsCompleted = {} as form12StatusInfoType;
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form12" }); 
    }
}
